import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import 'weather-icons/css/weather-icons.css'

import Header from './components/Header/Header.js'
import PageNotFound404 from './components/PageNotFound404/PageNotFound404.js'
import Home from './components/Home/Home.js'
import AboutUs from './components/AboutUs/AboutUs.js'
import Footer from './components/Footer/Footer.js'
import Login from './components/Forms/Login/Login.js'
import SignUp from './components/Forms/SignUp/SignUp.js'
import Policies from './components/Guidelines/Policies.js'
import Planning from './components/PlanningTrip/PlanningTrip.js'
import Weather from './components/Weather/Weather.js'
import Booking from './components/Forms/Booking/Booking.js'
import BookingEnquiry from './components/Forms/BookingEnquiry/BookingEnquiry.js'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary.js'
import Rental from './components/Rental/Rental.js'
import './App.css';

export default function App() {
  return (
    <ErrorBoundary>
      <div className="page-container">
        <div className="content-wrap">
          <Router>
            <Header/>
            <Routes>
              <Route path="/" element={<Home />}></Route>
              <Route path="/aboutus" element={<AboutUs/>}></Route>
              <Route path="/signup" element={<SignUp/>}></Route>
              <Route path="/login" element={<Login/>}></Route>
              <Route path="/policies" element={<Policies/>}></Route>
              <Route path="/planning" element={<Planning/>}></Route>
              <Route path="/weather" element={<Weather/>}></Route>
              <Route path="/booking" element={<Booking/>}></Route>
              <Route path="/booking-enquiry" element={<BookingEnquiry/>}></Route>
              <Route path="/rental" element={<Rental/>}></Route>
              <Route path="/404" element={<PageNotFound404/>}></Route>
              <Route path="*" element={<PageNotFound404/>}></Route>
            </Routes>
          </Router>
        </div>
        <Footer/>
      </div>
    </ErrorBoundary>
  );
}
